import CheckIcon from '@mui/icons-material/CheckCircle'
import { TableCell, TableRow } from '@mui/material'
import cn from 'classnames'
import noop from 'lodash/noop'
import omit from 'lodash/omit'
import React from 'react'
import { Mutation } from 'react-apollo'
import DeleteButton from '../../../common/iconButtons/DeleteButton'
import EditButton from '../../../common/iconButtons/EditButton'
import RestrictedView from '../../auth/RestrictedView'
import { i18n } from '../../index'
import { deleteCheckListItemMutation } from './checklistQueries'
import css from './checklistTable.css'
import type { ChecklistItem } from './checklistTypes'
type Props = {
  data: ChecklistItem
  onEdit: (...args: Array<any>) => any
  onDelete: (...args: Array<any>) => any
  stationId: string
}

class ChecklistRow extends React.PureComponent<Props> {
  weekDaysToDisplay() {
    const { days } = this.props.data

    if (days.length) {
      return days.length === 7
        ? i18n.t('admin.checklists.label.everyDay')
        : days.map((d) => i18n.t(`admin.checklists.label.weekDayAvailability.${d.toLowerCase()}`)).join(', ')
    } else {
      return i18n.t('admin.checklists.label.noDay')
    }
  }

  render() {
    const { data, onEdit, onDelete } = this.props
    return (
      <TableRow>
        <TableCell className={cn(css.tableCell, css.descriptionCell)}>{data.description}</TableCell>
        <TableCell className={css.tableCell}>{this.weekDaysToDisplay()}</TableCell>
        {['morning', 'evening', 'night'].map((shift, i) => {
          return (
            <TableCell className={css.checkboxCell} padding='checkbox' key={i}>
              <CheckIcon className={data.shiftStatus[shift] === 'Available' ? css.checkIconChecked : css.checkIcon} />
            </TableCell>
          )
        })}
        <TableCell className={css.actionsCell} align='right'>
          <RestrictedView requiredPermission='manage_ownStation'>
            <EditButton
              className={css.actionButton}
              onClick={() => (data.id ? onEdit(omit(data, ['__typename'])) : noop)}
            />
            <Mutation mutation={deleteCheckListItemMutation}>
              {(onMutate) => (
                <DeleteButton
                  className={css.actionButton}
                  onClick={() => (data.id ? onDelete(onMutate, data.id) : noop)}
                />
              )}
            </Mutation>
          </RestrictedView>
        </TableCell>
      </TableRow>
    )
  }
}

export default ChecklistRow
